export const PRIVACY_CONSTANTS = {
  EFFECTIVE_DATE: 'effectiveDate',
};
